/** Tipos de reação do Instagram/Messenger (campo `reaction`, não `emoji`). */
const REACTION_TYPE_TO_EMOJI: Record<string, string> = {
  love: "❤️",
  like: "👍",
  laugh: "😂",
  smile: "😊",
  wow: "😮",
  sad: "😢",
  angry: "😠",
  dislike: "👎",
};

/** Símbolos Unicode que costumam vir sem seletor de apresentação emoji (❤ → contorno branco). */
function withEmojiPresentation(value: string): string {
  if (value.includes("\uFE0F")) return value;
  if (value === "\u2764" || value === "\u2665") return "\u2764\uFE0F";
  return value.replace(/\u2764(?!\uFE0F)/g, "\u2764\uFE0F");
}

/**
 * Normaliza reação para exibição/gravação: tipos IG ("love") → emoji colorido;
 * ❤ sem U+FE0F → ❤️.
 */
export function normalizeReactionEmoji(raw: string | null | undefined): string {
  const trimmed = (raw ?? "").trim();
  if (!trimmed) return "❤️";

  const mapped = REACTION_TYPE_TO_EMOJI[trimmed.toLowerCase()];
  if (mapped) return mapped;

  return withEmojiPresentation(trimmed);
}

/** Máx. 10 caracteres (coluna `message_reactions.reaction`). */
export function normalizeReactionForStorage(raw: string | null | undefined): string {
  return normalizeReactionEmoji(raw).slice(0, 10);
}
